import { Group, Progress, Stack, Text } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import { useFormat } from '@/components/useFormat';
import type { VectorProgress } from '@/map/vectorSource';
import { brand } from '@/theme/theme';

/** One bar for every vector layer still arriving or being parsed; nothing once all are drawn. */
export function VectorLoadProgress({ progress }: { progress: Record<string, VectorProgress> }) {
  const { t } = useTranslation('reports');
  const { number } = useFormat();
  const entries = Object.entries(progress);
  if (entries.length === 0) return null;
  const mb = (b: number) => number(b / 1048576, 0);
  return (
    <Stack gap="xs" data-testid="vector-progress" className="report-actions">
      {entries.map(([object, p]) => {
        const counted = p.done !== undefined && p.total !== undefined && p.total > 0;
        const pct = counted ? (p.done! / p.total!) * 100 : 0;
        return (
          <Stack key={object} gap={4}>
            <Group justify="space-between">
              <Text fz={13} c={brand.textMuted}>
                {p.phase === 'downloading'
                  ? t('page.vectorDownloading', { done: mb(p.done), total: mb(p.total) })
                  : t(`page.vectorReading.${p.step}`, { done: number(p.done ?? 0, 0), total: number(p.total ?? 0, 0) })}
              </Text>
            </Group>
            <Progress value={counted ? pct : 100} color="forest.6" bg="forest.0" size="sm" radius="sm" animated={!counted} />
          </Stack>
        );
      })}
    </Stack>
  );
}
